/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appHiBob_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly hiBobEnabled: boolean | null;
        readonly workatoCustomerId: string | null;
        readonly workatoForecastHiBobConnectionId: string | null;
        readonly workatoHiBobConnectionId: string | null;
        readonly workatoIframeToken: string | null;
    } | null;
    readonly " $refType": "appHiBob_viewer";
};
export type appHiBob_viewer$data = appHiBob_viewer;
export type appHiBob_viewer$key = {
    readonly " $data"?: appHiBob_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appHiBob_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appHiBob_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hiBobEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoCustomerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoForecastHiBobConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoHiBobConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoIframeToken",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'cf4af1ed409fba0c75ad5645cd56ca7c';
export default node;
